import { render, staticRenderFns } from "./ym.vue?vue&type=template&id=28bed86c&scoped=true&"
import script from "./ym.vue?vue&type=script&lang=js&"
export * from "./ym.vue?vue&type=script&lang=js&"
import style0 from "./ym.vue?vue&type=style&index=0&id=28bed86c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bed86c",
  null
  
)

export default component.exports